<template>
    <div v-if="!loading" class="pb-25">
        <div class="d-flex justify-content-center w-100 text-center">
            <b-img v-if="!isReconnecting && !loading2" fluid src="@/assets/images/illustration/home.svg"
                style="width: 70vh;" />
            <b-img v-else fluid src="@/assets/images/illustration/home-danger.svg" style="width: 70vh;" />
        </div>
        <div v-if="certificateId || certificateId == 0">
            <Printer ref="Printer" :chefInvoice="orderPrint" :provider="provider" />
        </div>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BBadge, BSpinner, BImg } from 'bootstrap-vue';
import * as signalR from '@microsoft/signalr';
import { storeService } from '@core/services';
import Printer from '@/@core/components/printer/index.vue';

export default {
    components: {
        Printer,
        BImg,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BSpinner,
        BBadge
    },
    data() {
        return {
            loading2: true,
            certificateId: null,
            orderPrint: {},
            loading: true,
            connection: null,
            provider: {},
            storeId: null,
            printQueue: [],
            isPrinting: false,
            selfStop: false,
            printers: [],
            isReconnecting: false,
            isConnecting: false,
            reconnectIntervalId: null,
            lastDailyNumberId: null,
            lastPrinterId: null
        }
    },
    methods: {
        handlingPrintQueue(orders) {
            if (this.certificateId || this.certificateId == 0) {
                for (let order of orders) {
                    let orderCurrent = {};
                    orderCurrent = order
                    orderCurrent.id = `${order.dailyNumber}${order.printerId}`;
                    this.lastDailyNumberId = order.dailyNumber
                    this.lastPrinterId = order.printerId
                    this.registerOrder(orderCurrent);
                }
            }
        },
        async ordersForSyncPrint() {
            if (this.lastDailyNumberId && this.lastPrinterId) {
                await storeService.ordersForSyncPrint(this.storeId, this.lastDailyNumberId, this.lastPrinterId).then(({ data }) => {
                    this.handlingPrintQueue(data.orders)
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                })
            }
        },
        getPrinter() {
            storeService.getPrinter(this.storeId).then(({ data }) => {
                this.printers = data.items
                this.loading = false
                setTimeout(() => {
                    this.loading2 = false
                }, 2000);
            })
        },
        registerOrder(order) {
            this.printQueue.push(order);
            if (!this.isPrinting) {
                this.startPrinting();
            }
        },
        startPrinting() {
            this.isPrinting = true;
            const printNext = () => {
                if (this.printQueue.length === 0) {
                    this.isPrinting = false;
                    return;
                }
                this.orderPrint = null
                this.orderPrint = this.printQueue[0]
                this.orderPrint.printers = this.printers.find(printer => printer.id === this.printQueue[0].printerId);
                setTimeout(() => {
                    this.$refs.Printer.printChefInvoice();
                }, 100);
                this.removeFromQueueById(this.printQueue[0].id);
                setTimeout(printNext, 1000);
            };
            printNext();
        },
        removeFromQueueById(orderId) {
            this.printQueue = this.printQueue.filter(order => order.id !== orderId);
        },
        async startConnection() {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`${process.env.VUE_APP_BASE_URL_Socket}hubs/orders`, {
                    accessTokenFactory: () => localStorage.getItem("accessToken"),
                    withCredentials: false,
                    transport: signalR.HttpTransportType.WebSockets,
                })
                .configureLogging(signalR.LogLevel.Critical)
                .build();
            this.connection.on("OrdersPrint", (orders) => {
                this.handlingPrintQueue(orders)
            });
            await this.tryConnect();
            this.connection.onclose(() => {
                if (!this.selfStop) {
                    this.startReconnectionCycle();
                }
            });
            return this.connection;
        },
        async tryConnect() {
            if (this.selfStop) return;
            if (this.isConnecting) return;
            this.isConnecting = true;
            try {
                await this.connection.start();
                await this.connection.send('ConnectToPrinterOrdering');
            } catch (err) {
                setTimeout(() => {
                    this.isConnecting = false;
                    this.tryConnect();
                }, 5000);
                return;
            }
            this.isConnecting = false;
        },
        startReconnectionCycle() {
            if (this.isReconnecting) return;
            this.isReconnecting = true;
            this.reconnectIntervalId = setInterval(async () => {
                if (this.selfStop) {
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                    return;
                }
                if (!this.connection) {
                    await this.startConnection();
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                    return;
                }
                if (this.connection.state !== signalR.HubConnectionState.Connected) {
                    try {
                        if (!this.isConnecting) {
                            await this.ordersForSyncPrint()
                            await this.connection.start();
                            await this.connection.send('ConnectToPrinterOrdering');
                        }
                    } catch (err) { }
                } else {
                    clearInterval(this.reconnectIntervalId);
                    this.isReconnecting = false;
                }
            }, 5000);
        },
        getStoreDetails() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                data.name_Fa ? this.provider.name = data.name_Fa : this.provider.name = data.name_En;
                this.provider.logo = data.logoImage;
                this.getPrinter()
            })
        },
    },
    async mounted() {
        this.certificateId = localStorage.getItem("certificateId");
        this.storeId = localStorage.getItem("storeId")
        if (this.certificateId || this.certificateId == 0) {
            this.getStoreDetails()
            this.connection = await this.startConnection();
        }
        else {
            this.loading = false
            setTimeout(() => {
                this.loading2 = false
            }, 2000);
        }
    },
    beforeDestroy() {
        this.selfStop = true;
        if (this.reconnectIntervalId) {
            clearInterval(this.reconnectIntervalId);
        }
        if (this.connection) {
            this.connection.stop();
        }
    },
};
</script>